module.exports = __webpack_public_path__ + "static/img/pro5.8909a91d.png";